<template>
  <div id="app" ref="app" v-loading="!getLoadingState" v-on:touchstart="disableDoubleTap">
    <div class="offline" v-if="isOffline">Vous êtes hors connexion</div>
    <router-view v-if="getLoadingState"></router-view>
    <el-dialog title="Nouvelle version" :visible.sync="getUpdateAppAlerte" width="30%">
      <span>Une nouvelle version de l'application est disponible, cliquez sur "OK" pour recharger l'application</span>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="updateStart" type="primary" @click="updateApp">OK</el-button>
        <div class="update-start" v-if="!updateStart">Chargement de la nouvelle version en cours</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'app',
  data() {
    return {
      user: false,
      updateStart: true,
      isOffline: false,
      socketState: 'unset',
      lastTouch: null,
      keyboard: '',
      keyboardOpen: false,
      initialScreenSize: 0,
      debugData: '',
      debugOn: false
    }
  },
  watch: {
    'getSocketReadyState': function (val, oldVal) {
      this.socketState = val
    }
  },
  computed: {
    ...mapGetters({
      getLoadingState: 'getLoadingState',
      getLastUpdate: 'newReservations/getLastUpdate',
      isVisibleUpdateAppAlerte: 'displayer/isVisibleUpdateAppAlerte',
      getUser: 'newUsers/getUser',
      getSocketReadyState: 'webSockets/getSocketReadyState'
    }),
    getUpdateAppAlerte: function () {
      if (this.$router.currentRoute.fullPath.toString().substr(1, 7) !== 'booking') {
        return this.isVisibleUpdateAppAlerte
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions({
      storeUser: 'newUsers/storeUser',
      logout: 'newUsers/logout',
      storePublicUser: 'newUsers/storePublicUser',
      updateCurrentDay: 'newReservations/updateCurrentDay',
      resetAllStore: 'resetAllStore',
      loadIpsAuthorised: 'loadIpsAuthorised',
      loadIpsCheckEnabeld: 'loadIpsCheckEnabeld',
      initServiceWorker: 'serviceWorker/initServiceWorker',
      checkNotificationAuth: 'serviceWorker/checkNotificationAuth',
      serviceWorkerMessageListener: 'serviceWorker/serviceWorkerMessageListener'
    }),
    ...mapMutations({
      setUpdateAppAlerte: 'displayer/setUpdateAppAlerte'
    }),
    updateApp: function () {
      this.updateStart = false
      this.resetAllStore().then(() => {
        this.setUpdateAppAlerte(false)
        this.updateStart = true
        window.localStorage.clear()
        window.location.reload()
      })
    },
    updateData: function () { },
    debug: function (message, element) {
      this.debugData += message
    },
    initSW: async function () {
      await this.initServiceWorker()
      this.checkNotificationAuth()
      this.serviceWorkerMessageListener()
    },
    disableDoubleTap: function (e) { },
    updateWindowSize: function () {
      window.lastInnerWidth = window.innerWidth
      window.lastInnerHeight = window.innerHeight
      window.lastOrientation = window.orientation
      // Stays the same for iOS, so that's our ticket to detect iOS keyboard
      window.lastBodyHeight = document.body.clientHeight
    },
    detectKeyboard: function () {
      // Orientation change or regular resize, no keyboard action
      let keyboardHeight = 0

      // No orientation change, keyboard opening
      if ((window.lastInnerHeight - window.innerHeight > 150) && window.innerWidth === window.lastInnerWidth) {
        keyboardHeight = window.lastInnerHeight - window.innerHeight
        this.updateWindowSize()
        return keyboardHeight
      }
      // Orientation change with keyboard already opened
      if (this.orientationChange() && document.body.classList.contains('keyboard-open')) {
        keyboardHeight = screen.height - window.topBarHeight - window.innerHeight
        this.updateWindowSize()
        return keyboardHeight
      }

      // No orientation change, keyboard closing
      if ((window.innerHeight - window.lastInnerHeight > 150) && window.innerWidth === window.lastInnerWidth) {
        keyboardHeight = -1
        this.updateWindowSize()
        return keyboardHeight
      }

      this.updateWindowSize()
      return keyboardHeight
    },
    orientationChange: function () {
      if (((window.lastOrientation === 0 || window.lastOrientation === 180) && (window.orientation === 0 || window.orientation === 180)) || ((window.lastOrientation === 90 || window.lastOrientation === -90) && (window.orientation === 90 || window.orientation === -90))) { return false }
      else { return true }
    },
    keyboardShift: function (keyboardHeight) {
      if (!document.body.classList.contains('keyboard-open')) document.body.classList.add('keyboard-open')
      document.body.setAttribute('style', `height: calc(100% + ${keyboardHeight}px);`)
      this.keyboardOpen = true
    },
    removeKeyboardShift: function () {
      document.body.classList.remove('keyboard-open')
      document.body.removeAttribute('style')
      this.keyboardOpen = false
    }
  },
  mounted: function () {
    const url = window.location.host
    if (url === 'staging.resa.ninja') this.debugOn = true
  },
  created: function () {
    // sepcific route check ips
    if (this.$router.currentRoute.name === 'PRedirect' || this.$router.currentRoute.name === 'Permanence') {
      this.loadIpsCheckEnabeld().then((enable) => {
        if (enable) {
          axios.get('https://api.ipify.org').then((ipChecked) => {
            this.loadIpsAuthorised().then((list) => {
              let controlList = []
              list.forEach((aIp) => {
                let splittedCIp = ipChecked.data.toString().split('.')
                let ipFound = Object.entries(aIp.split('.')).map((currentRange, index) => {
                  let min = 0
                  let max = 0
                  if (currentRange[1].indexOf('-') !== -1) {
                    min = Number(currentRange[1].split('-')[0])
                    max = Number(currentRange[1].split('-')[1])
                  } else {
                    min = max = Number(currentRange[1])
                  }
                  if (!(min <= Number(splittedCIp[index]) && Number(splittedCIp[index]) <= max)) {
                    return false
                  } else {
                    return true
                  }
                })
                let unvalid = ipFound.find((valid) => {
                  return valid === false
                })
                if (unvalid === undefined) controlList.push(true)
                else controlList.push(unvalid)
              })
              let found = controlList.find((element) => {
                return element === true
              })
              if (found === undefined) {
                this.$router.replace({ name: 'Restaurant' })
              }
              this.storeUser().catch(() => {
                this.logout()
              })
            })
          })
        } else {
          this.storeUser().catch(() => {
            this.logout()
          })
        }
      })
      // classic way for resto or booking
    } else {
      if (this.$router.currentRoute?.meta?.bookingNew !== true) {
        this.storeUser()
          .then(res => {
            if (this.$router.currentRoute.name === 'successapp' && res.role === 'Permanence') this.storePublicUser()
          })
          .catch(err => {
            console.error('Error on Store user', err)
            this.storePublicUser()
          })
      }
    }

    // check online mod offline
    this.isOffline = !window.navigator.onLine
    window.ononline = () => {
      this.isOffline = false
    }

    window.onoffline = () => {
      this.isOffline = true
    }

    // bug ios connexion data base
    window.onerror = function (error) {
      if (error.indexOf('An internal error was encountered in the Indexed Database server') >= 0) {
        console.error('window on error - refresh app')
        // Refresh the page to restore IndexedDb to a working state.
        window.location.reload()
      }
    }
  }
}
</script>

<style lang="scss">
@use "./styles/mixins";
@use "./styles/vars";

@font-face {
  font-family: 'Barlow';
  src: url("assets/fonts/Barlow-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Barlow';
  src: url("assets/fonts/Barlow-SemiBold.ttf") format("truetype");
  font-weight: 600;
  font-style: bold;
}

@font-face {
  font-family: 'Barlow';
  src: url("assets/fonts/Barlow-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: bold;
}

@font-face {
  font-family: 'Raleway';
  src: url("assets/fonts/Raleway-Light.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Raleway';
  src: url("assets/fonts/Raleway-Bold.ttf") format("truetype");
  font-weight: 600;
  font-style: bold;
}

@font-face {
  font-family: 'Catamaran';
  src: url("assets/fonts/Catamaran-Bold.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Comfortaa';
  src: url("assets/fonts/Comfortaa-Bold.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.update-start {
  color: #000;
  text-align: center;
  width: 100%;
  font-size: 12px;
}

.version {
  position: fixed;
  text-align: right;
  right: 23px;
  bottom: 5px;
  opacity: 0.2;
  font-weight: 100;
}

.refresh-btn {
  padding: 5px 7px;
}

.offline {
  text-align: center;
  line-height: 40px;
  background-color: var(--color_red_dark);
}

* {
  -webkit-tap-highlight-color: transparent;
}

body {
  margin: 0;
  font-family: 'Barlow', Arial, Helvetica, sans-serif;
  font-weight: 600;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--dark__main_color);
  overflow-y: hidden;
  overflow-x: auto;
  height: 100dvh;
  position: relative;
  -webkit-overflow-scrolling: auto;
  width: 100%;
  height: 100%;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  touch-action: manipulation;
  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  box-sizing: border-box;
}

html {
  height: 100%;
  overflow: hidden;
  position: relative;
  -webkit-overflow-scrolling: auto;
  touch-action: manipulation;
}

.scrollable {
  -webkit-overflow-scrolling: touch;
}

#app {
  color: var(--color_white);
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
  -webkit-overflow-scrolling: auto;
  //overflow-y: auto;
  touch-action: manipulation;

  @media (max-width: 1024px) {
    overflow-y: auto;
    /* enable smooth scrolling on iOS */
    /* -webkit-overflow-scrolling: touch; */
  }
}

p {
  word-break: normal;
}

main {
  text-align: center;
  margin-top: 40px;
}

header {
  margin: 0;
  height: 56px;
  padding: 0 16px 0 24px;
  background-color: #35495E;
  color: var(--color_white);

  span {
    display: block;
    position: relative;
    font-size: 20px;
    line-height: 1;
    letter-spacing: .02em;
    font-weight: 400;
    box-sizing: border-box;
    padding-top: 16px;
  }
}

.el-loading-mask {
  background-color: var(--dark__main_color);
}
</style>
